import dateFormat from '../utils/dateformat.js'


export default function (value, format = 'yyyy-mm-dd HH:MM', utc = false) {
  const todayText = '今天'
  const yesterdayText = '昨天'
  let date = value instanceof Date ? value : new Date(value)
  let today = new Date()
  let yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
    const today = todayText + ' ' + dateFormat(date,'HH:MM')
    return today
  } else if (date.getFullYear() === yesterday.getFullYear() && date.getMonth() === yesterday.getMonth() && date.getDate() === yesterday.getDate()) {
    return yesterdayText + ' ' + dateFormat(date,'HH:MM')
  } else if(date.getFullYear() !== yesterday.getFullYear()) {
    return dateFormat(date,'yyyy-mm-dd')
  } else {
    return dateFormat(value, format, utc)
  }
}